<template>
	<b-navbar toggleable="lg" sticky class="faq-category-navbar">
		<b-navbar-toggle target="nav-collapse">
			<span><i class="fa fa-align-left text-muted mr-2"></i> FAQ categories</span> <i class="fa fa-plus"></i>
		</b-navbar-toggle>
		<b-collapse id="nav-collapse" is-nav>
			<b-navbar-nav>
				<b-nav-item :to="{'name': 'Faqs'}">Help Home</b-nav-item>
				<b-nav-item :to="{'name': 'BookingFaqs'}" :active="active === 'booking'">Booking</b-nav-item>
				<b-nav-item :to="{'name': 'RepairFaqs'}" :active="active === 'repair'">The repair</b-nav-item>
				<b-nav-item :to="{'name': 'PaymentsFaqs'}" :active="active === 'payments'">Pricing &amp; payments</b-nav-item>
				<b-nav-item :to="{'name': 'GuaranteeFaqs'}" :active="active === 'guarantee'">Likewize Repair guarantee</b-nav-item>
				<b-nav-item :to="{'name': 'LocationFaqs'}" :active="active === 'location'">Where is Likewize Repair?</b-nav-item>
				<b-nav-item :to="{'name': 'TermsFaqs'}" :active="active === 'terms'">Terms &amp; privacy</b-nav-item>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
</template>

<script>
export default {
	name: "CategoryMenu",

	props: {
		active: null
	}
}
</script>

<style scoped>

</style>